import React, { useState } from 'react';
import api from '../services/api';

function CreateAgreement({ userId, onAgreementCreated }) {
  const [formData, setFormData] = useState({
    payeeId: '',
    thirdPersonId: '',
    amount: '',
    time: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!userId) {
      setError('Please enter your User ID first');
      return;
    }

    // Only payeeId and amount are required
    if (!formData.payeeId || !formData.amount) {
      setError('Please fill in Payee ID and Amount');
      return;
    }

    if (parseFloat(formData.amount) <= 0) {
      setError('Amount must be greater than 0');
      return;
    }

    // Validate time only if it's provided
    if (formData.time && parseInt(formData.time) <= 0) {
      setError('Time must be greater than 0 if provided');
      return;
    }

    // Check for direct transfer mode
    const isDirectTransfer = !formData.thirdPersonId && !formData.time;

    try {
      setLoading(true);
      const response = await api.createAgreement(
        userId,
        formData.payeeId,
        formData.thirdPersonId || null,
        parseFloat(formData.amount),
        formData.time ? parseInt(formData.time) : null
      );

      const transferType = isDirectTransfer ? 'Direct transfer' : 'Escrow agreement';
      setSuccess(`${transferType} created successfully! Agreement ID: ${response.agreementId}`);
      setFormData({
        payeeId: '',
        thirdPersonId: '',
        amount: '',
        time: '',
      });

      if (onAgreementCreated) {
        onAgreementCreated(response);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-card">
      <h2 style={{ marginBottom: '25px', color: '#333' }}>Create Settlement Agreement</h2>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="alert alert-info" style={{ marginBottom: '25px' }}>
        <strong>Settlement Modes:</strong>
        <ul style={{ marginTop: '10px', marginBottom: '0', paddingLeft: '20px' }}>
          <li><strong>Immediate Settlement:</strong> Leave "Validator Institution" and "Expiration Time" empty for instant Centro transfer</li>
          <li><strong>Escrow Settlement:</strong> Specify all fields to hold Centro in escrow with third-party validation</li>
        </ul>
      </div>

      <div style={{ marginBottom: '25px', padding: '15px', background: '#e8f4f8', borderRadius: '10px', border: '1px solid #b3d9e6' }}>
        <strong style={{ color: '#1a365d' }}>Sender Institution:</strong>
        <span style={{ marginLeft: '10px', color: '#2d5a7b', fontWeight: '600' }}>{userId}</span>
        <p style={{ color: '#2d5a7b', marginTop: '5px', fontSize: '0.85rem', marginBottom: '0' }}>
          You are creating this agreement as the sender (Centro will be deducted from your account)
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="payeeId">
            Beneficiary Institution ID <span style={{ color: '#f44336' }}>*</span>
          </label>
          <input
            type="text"
            id="payeeId"
            name="payeeId"
            value={formData.payeeId}
            onChange={handleChange}
            placeholder="Enter beneficiary institution identifier"
            disabled={loading}
            required
          />
          <small style={{ color: '#666', fontSize: '0.85rem' }}>
            The institution that will receive the reserve transfer
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="thirdPersonId">
            Validator Institution ID (Optional)
          </label>
          <input
            type="text"
            id="thirdPersonId"
            name="thirdPersonId"
            value={formData.thirdPersonId}
            onChange={handleChange}
            placeholder="Leave empty for immediate settlement"
            disabled={loading}
          />
          <small style={{ color: '#666', fontSize: '0.85rem' }}>
            Institution authorized to validate and release the escrow (leave empty for immediate settlement)
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="amount">
            Centro Amount <span style={{ color: '#f44336' }}>*</span>
          </label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            placeholder="Enter Centro amount"
            step="0.01"
            disabled={loading}
            required
          />
          <small style={{ color: '#666', fontSize: '0.85rem' }}>
            Amount of Centro to transfer or hold in escrow
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="time">
            Escrow Expiration (seconds) (Optional)
          </label>
          <input
            type="number"
            id="time"
            name="time"
            value={formData.time}
            onChange={handleChange}
            placeholder="Leave empty for immediate settlement"
            disabled={loading}
          />
          <small style={{ color: '#666', fontSize: '0.85rem' }}>
            Duration until escrow expires and reserves return to sender (e.g., 86400 = 24 hours). Leave empty for immediate settlement.
          </small>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Processing Settlement...' : (!formData.thirdPersonId && !formData.time ? 'Initiate Immediate Settlement' : 'Create Escrow Agreement')}
        </button>
      </form>

      
    </div>
  );
}

export default CreateAgreement;
